//lib

//redux
import { useSelector } from "react-redux";

//component
import Col from "../../../components/element/col";
import Row from "../../../components/element/row";
import Image from "../../../components/element/image";
import { Logo, Sample } from "../../../assets/images";
import Button from "../../../components/element/button";
import ArrowButton from "../../../components/common/common.arrow.button";
import Container from "../../../components/element/container";
import CommonTitle from "../../../components/common/common.title";
import Icon from "../../../components/element/icon";
import useWindowDimension from "../../../components/hook/use.window.dimension";
import { useState } from "react";

export default function HomeFaq() {
  const { width } = useWindowDimension();
  const { faqList } = useSelector((state) => state.home);

  const [expandFaq, setExpandFaq] = useState([]);

  const handleExpandFaq = (index) => {
    setExpandFaq((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  return (
    <Container className="home-faq">
      <Row className="_row faq">
        <Col className="_col faq">
          <CommonTitle
            title="Questions"
            subtitle="Frequently Ask"
            className="px-5 py-5"
          />
        </Col>
        <Col className="_col faq-list w-100">
          {faqList.map((faq, faqIndex) => {
            const isExpanded = expandFaq.includes(faqIndex);

            return (
              <Row
                className={`_row faq-item ${
                  isExpanded ? "--expanded" : ""
                } pointer`}
                key={faqIndex}
                onClick={() => handleExpandFaq(faqIndex)}
              >
                <Col className="w-100 v-flex gap-4">
                  <Row className="w-100 h-flex justify-between items-start flex-nowrap">
                    <Row
                      className={`h-flex items-start flex-nowrap gap-${
                        width > 500 ? 4 : 2
                      }`}
                    >
                      <h6 className="_label faq-title">0{faqIndex + 1}.</h6>
                      <h6 className="_label faq-title">{faq.label}</h6>
                    </Row>
                    <Icon
                      className="_svg arrow"
                      icon="iconamoon:arrow-down-2"
                    />
                  </Row>
                  <p
                    className="_label faq-subtitle"
                    style={{
                      overflow: "hidden",
                      opacity: isExpanded ? 1 : 0,
                      maxHeight: isExpanded ? "1000px" : "0px",
                      transition: "max-height 0.3s ease, opacity 0.3s ease",
                    }}
                  >
                    {faq.description}
                  </p>
                </Col>
              </Row>
            );
          })}
        </Col>
      </Row>
    </Container>
  );
}
